function main() {
  const registerBtn = document.querySelector('#registerInterest');
  if (registerBtn) {
    registerBtn.addEventListener('click', function() {
      document.querySelector('#form-project-region').value = this.getAttribute(
        'data-project'
      );
      document.querySelector(
        '#form-project-name'
      ).value = this.getAttribute('data-project-name');
    });
  }
}
export default main;
